import React from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import BrandLogo from 'components/BrandLogo';
import LWTypography from 'components/legacy/LWTypography';
import useSupportPhoneNumbers from 'modules/queries/support/usePhoneNumbers';

const FullScreenError = ({
	title = 'Whoops!',
	headerText = 'Error',
	subHeaderText = 'An error occurred.',
	content = 'Refresh to try again. Contact support if this error persists.',
}) => {
	const { data: supportPhoneNumberData } = useSupportPhoneNumbers({
		separate_toll_free: true,
	});
	const phoneNumbers = supportPhoneNumberData?.support;
	const usPhoneNumber = Array.isArray(phoneNumbers)
		? phoneNumbers[0]
		: phoneNumbers?.toll_free?.[0] || '800-580-4985';
	const internationalPhoneNumber = Array.isArray(phoneNumbers)
		? phoneNumbers[1]
		: phoneNumbers?.other?.[0] || '1.517.322.0434';

	return (
		<Grid container direction="column" alignItems="center">
			<BrandLogo sx={{ width: '3.5em', height: 'auto', margin: 400 }} />
			<LWTypography variant="h2" light color="palette.primary.main">
				{title}
			</LWTypography>
			<Paper component={Box} mx={4} my={1} p={7} maxWidth="600px">
				<LWTypography variant="h4" BoxProps={{ mb: 1 }}>
					{headerText}
				</LWTypography>
				<LWTypography variant="subtitle1" semiBold>
					{subHeaderText}
				</LWTypography>
				<LWTypography BoxProps={{ my: 4 }}>{content}</LWTypography>
				<LWTypography color="textSecondary">US: {usPhoneNumber}</LWTypography>
				<LWTypography color="textSecondary">
					International: {internationalPhoneNumber}
				</LWTypography>
			</Paper>
		</Grid>
	);
};

FullScreenError.propTypes = {
	/** Text displayed at the very top of the page */
	title: PropTypes.string,
	/** Text displayed at the top of the box */
	headerText: PropTypes.string,
	/** Text displayed below the headerText */
	subHeaderText: PropTypes.string,
	/** Remaining text content on the page */
	content: PropTypes.string,
};

export default FullScreenError;
